// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__24yiS","notes":"Notes_notes__32OtT"};